/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import GiftcardInfoText from 'app/modules/cinemaRent/components/GiftcardInfo';
import { BonusInfoWrapper } from './styles';

const propTypes = {
  locations: PropTypes.array.isRequired,
  cinemas: PropTypes.array.isRequired,
  fetchLocation: PropTypes.func.isRequired,
  getchLocationCinemas: PropTypes.func.isRequired,
  clearState: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  getDates: PropTypes.func.isRequired,
  setDates: PropTypes.func.isRequired,
  dates: PropTypes.arrayOf(PropTypes.string).isRequired,
  savedLocation: PropTypes.string.isRequired,
  content: PropTypes.array.isRequired,
  requestContent: PropTypes.func.isRequired
};

const defaultProps = {
  locations: null,
  pdf: null
};

const GiftCardInfo = ({
  locations,
  fetchLocation,
  clearState,
  getDates,
  getchLocationCinemas,
  cinemas,
  requestContent,
  content
}) => {
  const newDate = new Date();
  // eslint-disable-next-line no-unused-vars
  const date = newDate.getDate();
  // eslint-disable-next-line no-unused-vars
  const month = newDate.getMonth() + 1;
  // eslint-disable-next-line no-unused-vars
  const year = newDate.getFullYear();
  const [t, i18n] = useTranslation();
  // eslint-disable-next-line no-unused-vars
  const [loaded, setLoaded] = useState(false);
  const [dataLocation, setdataLocation] = useState([]);

  useEffect(() => {
    fetchLocation();

    return () => clearState();
  }, [i18n.language]);

  useEffect(() => {
    requestContent()
  }, []);

  useEffect(() => {
    if (locations) {
      setLoaded(true);
      getDates();
      getchLocationCinemas();
    }
  }, [locations]);

  useEffect(() => {
    if (locations?.length > 0) {
      const newData = [];

      locations.map(item_ => {
        const ids_list = item_.items; // item list

        const data_list_array = [];

        const dataArray = [];

        ids_list.map(id => {
          cinemas.some(element => {
            if (Number(element.id) === id) {
              data_list_array.push(element.name);
              dataArray.push(element);
            }
          });
        });

        const data_array = {
          item: item_,
          list: data_list_array,
          data_array: dataArray
        };

        newData.push(data_array);
        setdataLocation(newData);
      });
    }
  }, [cinemas]);

  return (
    <BonusInfoWrapper>
      <h1 className="bonus-info__title">{t('common.giftcard_info')}</h1>
      <div className="container">
        <GiftcardInfoText
          data={dataLocation}
          content={content} />
      </div>
    </BonusInfoWrapper>
  );
};

GiftCardInfo.propTypes = propTypes;
GiftCardInfo.defaultProps = defaultProps;
export default GiftCardInfo;
